import { useDispatch } from "store";
import { finishTour } from "store/slices/tour";
// components
import { CardComponentProps } from "nextstepjs";

// material-ui
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Stack,
} from "@mui/material";

// third-party
import { FormattedMessage } from "react-intl";

const TourCard = ({
  step,
  currentStep,
  totalSteps,
  nextStep,
  prevStep,
  skipTour,
  arrow,
}: CardComponentProps) => {
  const dispatch = useDispatch();
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;
  const showSkip = step.showSkip && skipTour;
  const tourId = step.selector?.substring(1, step.selector.length - 1);

  const handleSkipTour = () => {
    dispatch(finishTour(tourId));
    skipTour && skipTour();
  };

  const handleNextTour = () => {
    if (isLastStep) dispatch(finishTour(tourId));

    nextStep();
  };

  return (
    <Card sx={{ p: 2, width: 360 }}>
      <Stack direction='column' spacing={2}>
        <Stack direction='column' spacing={1}>
          <CardHeader
            sx={{ p: 0 }}
            title={
              <Stack direction='row' spacing={1}>
                {step.icon && <Typography variant='h4'>{step.icon}</Typography>}
                <Typography variant='h4'>
                  <FormattedMessage id={step.title} />
                </Typography>
              </Stack>
            }
          />
          <CardContent style={{ padding: 0 }}>
            <Typography variant='body2'>
              <FormattedMessage id={step.content as string} />
            </Typography>
          </CardContent>
        </Stack>
        <Stack spacing={1} justifyContent='space-between'>
          <Stack direction='row' spacing={1}>
            <Button
              fullWidth
              onClick={prevStep}
              disabled={isFirstStep}
              color='info'
              variant='outlined'
            >
              <FormattedMessage id={"back"} />
            </Button>
            <Button
              fullWidth
              onClick={handleNextTour}
              color='info'
              variant='contained'
            >
              <FormattedMessage id={isLastStep ? "finish" : "next"} />
            </Button>
          </Stack>
          {!isLastStep && showSkip && (
            <Button variant='outlined' onClick={handleSkipTour}>
              <FormattedMessage id={"skip"} />
            </Button>
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

export default TourCard;
